<template>
  <div class="Current-left">
    <div class="Current-head">
      <div class="Current-sculpture">
        <img :src="user.user.avatar?user.user.avatar:'images/grzx.png'">
      </div>
      <div class="Current-name">{{user.user.name}}</div>
    </div>

    <div class="Current-sub">
      <router-link to="/pernews" :class="Path == '/pernews'?'on':''">消息通知</router-link>
      <router-link to="/perrele" :class="Path == '/perrele'?'on':''">我的发布</router-link>
      <router-link to="/perfriend" :class="Path == '/perfriend'?'on':''">我的好友</router-link>
      <router-link to="/perecon" :class="Path == '/perecon'?'on':''">至德经济</router-link>
      <router-link to="/permem" :class="Path == '/permem'?'on':''">我的纪念堂</router-link>
      <router-link to="/perbasis" :class="Path == '/perbasis'?'on':''">基础资料</router-link>
    </div>

    <div class="Current-exit" @click="Exit">退出</div>
</div>
</template>

<script>
  export default {
    name: 'AllLeft',
    props: {
      avatarUrl: String
    },
    data(){
        return{
          token: localStorage.pctoken,    //获取token
          user: JSON.parse(localStorage.user),
          Path:'',
          isread:'',
          usinfo:[],
        }
    },
    created(){
      this.Path = this.$router.currentRoute.path;
      
    },
    mounted() {
      let that = this;
      window.addEventListener("setItemEvent", function (e) {
        that.user = JSON.parse(e.newValue)
      })
    },
    methods:{
      Exit(){
        localStorage.removeItem('pctoken');
        localStorage.removeItem('user');
        this.$router.push({name:"login"});
      },
    }
  }
</script>

<style scoped>
  .Current-left{
    width: 250px;
    height: 700px;
    background: #fff;
    border-radius: 20px 0 0 0;
    position: relative;
  }
  .Current-head{
   
  }
  .Current-sculpture{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin: 0 auto;
    padding-top: 36px;
  }
  .Current-sculpture img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #DCEEFF;
  }
  .Current-name{
    font-size: 16px;
    color: #000000;
    text-align: center;
    margin-top: 20px;
  }
  .Current-sub{
    width: 200px;
    margin: 36px auto 0;
  }
  .Current-sub a{
    display: block;
    width: 200px;
    height: 36px;
    background: #D8D8D8;
    margin-top: 16px;
    font-size: 16px;
    color: #666;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    border-radius: 18px;
  }
  .Current-sub a:hover{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    color: #fff;
  }
  .Current-sub .on{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    color: #fff;
  }
  .Current-dot{
    line-height: 35px !important;
  }
  ::v-deep .Current-dot .el-badge__content.is-fixed.is-dot{
    right: -4px;
    top: 11px;
  }  
  .Current-exit{
    width: 200px;
    height: 36px;
    background: #D8D8D8;
    border-radius: 18px;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translate(-50%,0);
    cursor: pointer;
  }
</style>
